/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Attack: 0,
  Attrition: 1,
  Neighbor: 2,
  Sector: 3,
  Platform: 4,
};
